import { FC, ReactNode, MouseEventHandler } from 'react';
import classnames from 'classnames';
import CheckmarkIcon from 'dibs-icons/exports/Checkmark';
import styles from './styles/DropdownItem.scss';

type Props = {
    onClick: MouseEventHandler;
    label: ReactNode;
    selected: boolean;
    dataTn: string;
    id: string;
    focused: boolean;
};

const DropdownItem: FC<Props> = ({ focused, id, onClick, label, selected, dataTn }) => (
    <li
        id={id}
        role="option"
        onClick={onClick}
        aria-selected={focused ? 'true' : 'false'}
        className={classnames(styles.option, { [styles.focused]: focused })}
        data-tn={dataTn}
    >
        {selected && <CheckmarkIcon className={styles.checkmark} />}
        <span className={styles.optionLabel}>{label}</span>
    </li>
);
export default DropdownItem;
